{
  "fr": {
    "uppy": {
      "exceedsSize": "Le fichier dépasse la taille maximale autorisée de %{size}",
      "youCanOnlyUploadFileTypes": "Vous ne pouvez télécharger que : %{types}",
      "youCanOnlyUploadX": {
        "0": "Vous ne pouvez télécharger que %{smart_count} fichier",
        "1": "Vous ne pouvez télécharger que %{smart_count} fichiers"
      }
    },
    "sidebar": {
      "show_less": "Afficher moins",
      "show_more": "Afficher plus"
    }
  }
}
